(() => {
  // Decorative motion stops while offscreen; product links and forms need no JavaScript.
  const snow = document.querySelector('.hz-christmas-snow');
  if (!snow || !('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver(([entry]) => {
    snow.querySelectorAll('i').forEach((flake) => {
      flake.style.animationPlayState = entry.isIntersecting ? 'running' : 'paused';
    });
  });
  observer.observe(snow);
})();
